import jwt from 'corp-front-vue-commons/src/utils/jwt'
import { mapByGroup } from 'corp-front-vue-commons/src/utils/claims'
import { SESSION_HEADERS } from 'utils/constants'

const token = JSON.parse(localStorage.getItem(SESSION_HEADERS))
let state = { groups: null }

if (token) {
  const { claims, ...noClaims } = jwt.decode(token.authorization)

  if (claims && noClaims && noClaims.business && noClaims.business.customClaims) {
    const customClaims = noClaims.business.customClaims
    state = { groups: mapByGroup(claims.concat(customClaims)) }
  }
}

const actions = {
  add ({ commit }, payload) {
    commit('add', mapByGroup(payload))
  },

  clear ({ commit }) {
    commit('clear')
  }
}

const mutations = {
  add (state, payload) {
    state.groups = payload
  },

  clear (state) {
    state.groups = null
  }
}

const userClaims = {
  namespaced: true,
  state,
  actions,
  mutations
}

export default userClaims
